var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNdovuLogoNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 37,
    viewBox: "0 0 31 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000004654"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.4463 18.4504C19.4463 20.3834 17.8793 21.9514 15.9463 21.9514C14.0133 21.9514 12.4463 20.3834 12.4463 18.4504C12.4463 16.5174 14.0133 14.9514 15.9463 14.9514C17.8793 14.9514 19.4463 16.5174 19.4463 18.4504Z",
    fill: "#DB2A12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000004651"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1525",
    cx: 15.2727,
    cy: 4.99073,
    r: 4.16529,
    fill: "#FFCD47"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1527",
    cx: 26.3801,
    cy: 10.5444,
    r: 4.16529,
    fill: "#FFCD47"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1526",
    cx: 4.16529,
    cy: 10.5444,
    r: 4.16529,
    fill: "#FFCD47"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1528",
    cx: 4.16529,
    cy: 24.4287,
    r: 4.16529,
    fill: "#FFCD47"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1529",
    cx: 15.2727,
    cy: 32.7593,
    r: 4.16529,
    fill: "#FFCD47"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1530",
    cx: 26.3801,
    cy: 24.4287,
    r: 4.16529,
    fill: "#FFCD47"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNdovuLogoNew);
export default __webpack_public_path__ + "static/media/ndovuLogoNew.d9ac60ce1f68aca44092cb3d21373f29.svg";
export { ForwardRef as ReactComponent };